<template>
    <section>
        <transition-group name="modal">
            <div id="form_plano" class="modal-mask" key="duplicate" @click="close" v-show="show">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody" @click.stop>
                            <div class="_container_ rel">
                                <img src="../../assets/croix.png" width="20" height="20" alt="" @click="close" class="cross fright abs pointer" />
                                <div class="_result flexContainer full fd-c ai-c" v-if="openPlanoId !== null">
                                    <div class="full ai-c ff-medium txtCenter mt25">
                                        <span class="titles">{{ $t("plano.your_plano") }}</span>
                                        <span class="bold" style="color: red">{{ currentPlanoName }}</span>
                                    </div>
                                    <div class="full ai-c ff-medium txtCenter mt10">
                                        <span class="titles">{{ $t("plano.duplicate_message") }}</span>
                                        <span class="bold" style="color: red">{{ newPlano.name }}</span>
                                    </div>
                                    <div class="full ai-c ff-medium txtCenter mt25">
                                        <button @click="openPlano(newPlano);" class="btn rel iBlock pointer clear mobileNot txtCenter ">
                                            {{ $t("plano.open_plano") }}
                                        </button>
                                    </div>
                                    <div class="note full txtCenter">{{ $t("plano.note_duplicate_plano") }}</div>
                                </div>
                                <section class="fd-r fw-w m-jc-sb">
                                    <div class="flexContainer fd-c ai-c jc-fs">
                                        <p class="ff-light flexContainer fd-r jc-c">
                                            {{ $t("plano.duplicate_plano") }} &nbsp; <strong>{{ currentPlanoName }}</strong>
                                        </p>
                                        <div class="flexContainer fd-c">
                                            <label class="full ff-medium fleft labelName">{{ $t("plano.enter_new_name") }}</label>
                                            <input
                                                name=""
                                                class="full planoName mt10"
                                                v-model="newPlano.name"
                                                :placeholder="$t('plano.name_placeholder')"
                                            />
                                            <p class="danger" v-if="sameName">{{ $t("duplicatePlano.saveName") }}</p>
                                            <p class="danger" v-if="nullName">{{ $t("duplicatePlano.enterName") }}</p>
                                        </div>
                                        <div id="content">
                                            <p class="ff-light flexContainer fd-r jc-c">{{ $t("plano.select_campaign") }}</p>
                                            <p class="danger" v-if="nullCampaign">{{ $t("duplicatePlano.selectCampign") }}</p>
                                            <div class="flexContainer logoContainer jc-c fd-r fw-w m-jc-sb">
                                                <div class="brandWrap jc-c pointer" v-for="campaign in getCampaigns" :key="campaign.id">
                                                    <p
                                                        class="brandLogo txtCenter uppercase"
                                                        :class="[
                                                            selectedPlanoCampaign === campaign.id ? '_selectedCampaign' : '_notselectedCampaign',
                                                            ''
                                                        ]"
                                                        @click="updateCampaign(campaign.id, campaign);"
                                                    >
                                                        {{ campaign.name }}
                                                    </p>
                                                </div>
                                            </div>
                                            <p class="ff-light flexContainer fd-r jc-c">{{ $t("plano.select_zone") }}</p>
                                            <p class="danger" v-if="nullZone">{{ $t("duplicatePlano.selectZone") }}</p>
                                            <div class="flexContainer logoContainer jc-c fd-r fw-w m-jc-sb">
                                                <div class=" brandWrap jc-c pointer" v-for="zone in getZones" :key="zone.id">
                                                    <p
                                                        class="brandLogo txtCenter uppercase"
                                                        :class="[selectedPlanoZone === zone.id ? '_selectedZone' : '_notselectedZone', '']"
                                                        @click="updateZone(zone.id);"
                                                    >
                                                        {{ zone.name }}
                                                    </p>
                                                </div>
                                            </div>
                                            <p class="ff-light flexContainer fd-r jc-c">
                                                <button class="btn_validate pointer" @click="duplicatePlano">{{ $t("plano.btn_validate") }}</button>
                                            </p>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import "whatwg-fetch";
import httpService from "../../components/service";
import { mapGetters, mapActions } from "vuex";
import planoService from "@/services/plano";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import { openPlano } from "@/utils/plano";
import cacheService from "../../services/cache";

export default {
    data() {
        return {
            selectedPlanoZone: this.currentPlanoZone,
            selectedPlanoCampaign: this.currentPlanoCampaign,
            zoneChecked: this.planoZone,
            campChecked: this.planoCamp,
            newPlano: {
                id: null,
                name: null,
                zone: {
                    id: this.currentPlanoZone
                },
                campaign: {
                    id: this.currentPlanoCampaign
                }
            },
            openPlanoId: null,
            planos: [],
            sameName: false,
            nullName: false,
            nullZone: false,
            nullCampaign: false,
            getCampaigns: null
        };
    },
    props: {
        show: {},
        currentPlanoCampaign: {},
        currentPlanoZone: {},
        currentPlanoId: {},
        currentPlanoName: {},
        currentStandDesign: {}
    },
    mixins: [TryLoadMixin],
    methods: {
        ...mapActions("brand", {
            populateZones: "populateZones",
            populateCampaigns: "populateCampaigns"
        }),
        openPlano(plano) {
            cacheService.set("currentCampaignId", plano.campaign.id);
            cacheService.set("currentZoneId", plano.zone.id);
            openPlano.call(this, plano);
        },
        close() {
            this.$emit("close", false);
            this.selectedCampaign = null;
            this.selectedZone = null;
            this.newPlano.name = null;
            this.openPlanoId = null;
            this.sameName = false;
            this.nullName = false;
            this.nullZone = false;
            this.nullCampaign = false;
        },
        loadBrandsList() {
            this.populateZones();
            this.populateCampaigns();
        },
        updateZone(newId) {
            this.selectedPlanoZone = this.newPlano.zone.id = newId;
            this.checkListPlano();
        },
        updateCampaign(newId) {
            this.selectedPlanoCampaign = this.newPlano.campaign.id = newId;
            this.checkListPlano();
        },
        checkListPlano() {
            httpService
                .checkDuplicate(
                    this.selectedPlanoZone +
                        (this.selectedPlanoCampaign > 0 ? "/" + this.selectedPlanoCampaign : "") +
                        "/plano?limit=50&campaign=" +
                        this.selectedPlanoCampaign
                )
                .then(data => {
                    this.planos = [];
                    this.planos = data.data;
                });
        },
        async duplicatePlano() {
            this.sameName = false;
            this.nullName = false;
            this.nullZone = false;
            this.nullCampaign = false;

            let checkName = false;
            let canPlanoBeDuplicated = true;
            for (let i in this.planos) {
                if (
                    checkName === false &&
                    this.newPlano.name !== null &&
                    this.newPlano.name !== "" &&
                    this.newPlano.name !== this.planos[i].name &&
                    this.selectedPlanoZone !== null &&
                    this.selectedPlanoCampaign !== null
                ) {
                    canPlanoBeDuplicated = true;
                } else if (this.newPlano.name === this.planos[i].name && this.newPlano.name !== null) {
                    canPlanoBeDuplicated = false;
                    this.sameName = true;
                    checkName = true;
                }
            }
            if (this.newPlano.name === null || this.newPlano.name === "") {
                canPlanoBeDuplicated = false;
                this.nullName = true;
            }
            if (this.selectedPlanoZone === null) {
                canPlanoBeDuplicated = false;
                this.nullZone = true;
            }
            if (this.selectedPlanoCampaign === null) {
                canPlanoBeDuplicated = false;
                this.nullCampaign = true;
            }
            if (canPlanoBeDuplicated) {
                const response = await this.tryLoad(() => planoService.duplicate(this.currentPlanoId, this.newPlano));
                this.newPlano = response;
                this.openPlanoId = parseInt(response.id);
            }
        }
    },
    mounted() {
        this.loadBrandsList();
        document.addEventListener("keydown", e => {
            if (this.show && e.keyCode === 27) {
                this.close();
            }
        });
    },
    computed: {
        ...mapGetters({
            getResults: "planos/search/getResults"
        }),
        ...mapGetters("brand", {
            getZones: "getZones"
        })
    },
    created() {
        this.$store.dispatch("planos/search/getResults").then(() => {
            this.planos = this.getResults();
        });
        httpService.get("/admin/campaigns/list?limit=100").then(response => {
            this.getCampaigns = response.data;
        });
    }
};
</script>

<style lang="scss" scoped>
.titles {
    text-transform: uppercase;
    font-family: Roboto, Sans-Serif;
}

.note {
    font-family: Roboto, Sans-Serif;
    position: absolute;
    bottom: 50px;
    font-size: 10px;
    padding: 0 60px;
    font-weight: bold;
    text-align: justify;
}

._rem3rch_color {
    color: #41b4e8;
}

._result {
    position: absolute;
    padding-top: 40px;
    border-radius: 3px;
    top: 0;
    left: 0;
    height: calc(100%);
    width: 100%;
    background-color: white;
    z-index: 20;
    font-size: 200%;
}

.planoName {
    padding: 0.5em;
    font-size: 1.2em;
    border: none;
    border-bottom: 2px solid #333;
    width: 300px;
}

.brandLogo {
    cursor: hand;
}

label {
    font-size: 1.4rem;
}

.btn_validate,
.btn_open_plano {
    border-radius: 2em;
    padding: 6px 10px;
    background: white;
    border: 1px solid black;
}

._container_ {
    background-color: white;
    position: relative;
    border-radius: 3px;

    .cross {
        top: -10px;
        right: -10px;
        z-index: 25;
    }
}

._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}

/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;

        .logoContainer {
            width: 650px;

            .brandLogo:hover {
                background-color: #41b4e8;
                color: white;
            }

            .brandLogo {
                border-radius: 0.5rem;
                font-size: 12px;
                background-color: #f4f4f4;
                /* padding: 2px; */
                width: 130px;
                height: 40px;
                line-height: 40px;
                -webkit-margin-before: 0;
                -webkit-margin-after: 0;
                -webkit-margin-start: 0px;
                -webkit-margin-end: 0px;

                img {
                    margin: auto;
                }
            }
        }

        .modalBody {
            margin: auto;

            .brandWrap {
                margin: 2px;
            }

            p {
                font-family: Roboto;
                font-size: 1.4rem;
            }

            .danger {
                font-size: 1.2rem;
            }
        }
    }
}

@media only screen and (max-width: 767px) {
    .modal-wrapper {
        .modal-container {
            .logoContainer {
                width: auto;
                padding-left: 15px;
                padding-right: 15px;
            }
        }

        #content {
            height: calc(100vh - 180px);
            overflow-y: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// duplicate.vue?321f98ac